import { getOmpSearchString } from "@src/api/main/OMPTypes";
import { defineFilterConfig, filterFieldAdapters } from "@src/components/business-form";
import type { OnsideInvoiceFilter } from "../../../../../../api/onsideInvoices";

/** Значения формы фильтра списка НС для отгрузки СГП. */
export interface StockFinishedGoodsShipmentFilterFormValues {
    /** Код склада СГП. */
    senderCode: number | null;
    /** Код контрагента-получателя. */
    enterpriseCode: number | null;
    /** Номер НС. */
    num: string;
    /** Коды статусов НС. */
    stateCodes: number[];
}

/** Конфигурация фильтра списка НС для отгрузки СГП. */
export const stockFinishedGoodsShipmentFilterFormConfig = defineFilterConfig<
    StockFinishedGoodsShipmentFilterFormValues,
    OnsideInvoiceFilter
>({
    fields: {
        senderCode: {
            type: "number",
            nullable: true,
            label: "Склад СГП",
            validation: { required: true },
            map: filterFieldAdapters.singleCodeArray("WsSenderCodes"),
        },
        enterpriseCode: {
            type: "number",
            nullable: true,
            label: "Контрагент-получатель",
            map: filterFieldAdapters.singleCodeArray("EnterpriseCodes"),
        },
        num: {
            type: "string",
            label: "Номер НС",
            map: {
                from: (domain) => domain.Num?._query ?? domain.Num?.val ?? "",
                to: (value) => {
                    const trimmed = value.trim();
                    return { Num: getOmpSearchString(trimmed) };
                },
            },
        },
        stateCodes: {
            type: "array",
            label: "Статусы НС",
            map: filterFieldAdapters.entityCodes("StateCodes"),
        },
    },
});
